import { render, staticRenderFns } from "./Favorito_live.vue?vue&type=template&id=1556b87c&"
import script from "./Favorito_live.vue?vue&type=script&lang=js&"
export * from "./Favorito_live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports